<template>
    <div id="AreaMap">
            <v-marker-cluster ref="clusterRef">
            <l-marker
                    v-for="item in markers"
                    :key="item.id"
                    :lat-lng="item.position"
                    :icon="item.icon"
            >
                <l-popup>
                    <div @click="showPlace(item.id)">
                        {{ item.name }}
                    </div>
                </l-popup>
            </l-marker>
            </v-marker-cluster>

        <b-container fluid class = "footer text-center">
            {{ areaTitle }}
        </b-container>

    </div>

</template>

<script>
import { BContainer } from 'bootstrap-vue';
import 'leaflet/dist/leaflet.css';
require('@/assets/css/images/layers.png')
require('@/assets/css/images/marker-icon.png')
import L from 'leaflet';
import { latLng } from "leaflet";
import { LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "AreaMap",
  components: {
    BContainer,
    LMarker, LPopup, //LControl
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props: {
    map: Object,
  },
  data: function() {
    return {
      action: '',
      zoom: this.$store.state.curZoom,
      minZoom: 1,
      maxZoom: 18,
      center: latLng(55.75209, 37.61753),
      bounds: [],
      position: latLng(0, 0),
      //map: null,
      baseLayers: L.control.layers(),
      inRu: true,
      intLoc: this.$i18n.locale,
      //listLoc: '',
      country: '',
      district: '',
      city: '',
      m: [],
      markers: [],
      areaTitle: ''
    };
  },
  mounted() {
    //this.map = this.map;
    this.country = this.$route.params.country;
    this.district = this.$route.params.district;
    this.city = this.$route.params.city;
    //alert(this.city);
    this.getAreaMap();
  },
  methods: {
    async getAreaMap() {
        this.markers = [];
        try {
            //console.log(this.country, this.district, this.city, this.intLoc);
            const response = await this.$http.get('/getAreaMap', {
                params: {
                    country: this.country,
                    district: this.district,
                    city: this.city,
                    intLoc: this.intLoc
                }
            });
            this.m = response.data;
            if(!this.m.length) {
                this.$showMsg(this.$t('NO_LANG_RES'));
                this.$router.go(-1);
                return;
            }
            this.showAreaMarkers();
            this.getAreaTitle();
            //this.$emit('setPos');
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('AreaMap: getAreaMap() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async getAreaTitle() {
        try {
            const response = await this.$http.get('/getAreaTitle', {
                params: {
                    country: this.country,
                    district: this.district,
                    city: this.city,
                    intLoc: this.intLoc
                }
            });
            this.areaTitle = response.data;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('AreaMap: getAreaTitle() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    showAreaMarkers() {
        let minLat = 90.0; let minLng = 180.0; let maxLat = -90.0; let maxLng = -180.0;
        for(let i = 0; i < this.m.length; i++) {
            let item = {
                id: i,
                name: this.m[i].markName,
                position: latLng(this.m[i].markLat,this.m[i].markLng),
                icon: L.icon({
                    iconUrl : '/data/markers/'+this.m[i].markType+'.png',
                    iconSize : [35, 41],
                    iconAnchor : [12, 37]
                })
            };
            this.markers.push(item);
            if(this.m[i].markLat < minLat) minLat = this.m[i].markLat;
            if(this.m[i].markLng < minLng) minLng = this.m[i].markLng;
            if(this.m[i].markLat > maxLat) maxLat = this.m[i].markLat;
            if(this.m[i].markLng > maxLng) maxLng = this.m[i].markLng;
        }
        this.map.fitBounds( [[minLat, minLng], [maxLat, maxLng]]);
        //this.$refs.clusterRef.mapObject.refreshClusters();
        //this.$store.commit('setCurBounds', { minLat: minLat, minLng: minLng, maxLat: maxLat, maxLng: maxLng,  } );
        //this.$emit('setBounds');
    },
    showPlace(itemId) {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.m[itemId].markName)+'/'+this.$addEncHyp(this.m[itemId].userName)
        })
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getAreaMap();
    }

  }
}
</script>

<style >
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

/*
#Map{
    z-index: 10;
}
*/
</style>